import { useState } from "react";
import { IWarehouse } from "../../api/types";
import { usePutWarehouseMutation } from "../../api/putWarehouse.mutation";
import { EditButton } from "./EditButton";
import { DeleteButton } from "./DeleteButton";
import { ListItemsButton } from "./ListItemsButton";
import { useDeleteWarehouseMutation } from "../../api/deleteWarehouse.mutation";
import { Stack } from "react-bootstrap";

export const WarehouseTableRow = (props: { warehouse: IWarehouse }) => {
  const { warehouse: inputWarehouse } = props;
  const [warehouse, setWarehouse] = useState(inputWarehouse);
  const { mutate: putWarehouse } = usePutWarehouseMutation(inputWarehouse.id)
  const { mutate: deleteWarehouse } = useDeleteWarehouseMutation(inputWarehouse.id)
  const updateWarehouse = (updates: Partial<IWarehouse>) => {
    const newWarehouse = { ...warehouse, ...updates }
    putWarehouse(newWarehouse);
    setWarehouse(newWarehouse);
  }

  return <tr key={warehouse.id}>
    <td>{warehouse.name}</td>
    <td>
      <Stack gap={1} direction='horizontal'>
        <ListItemsButton warehouseId={warehouse.id} />
        <EditButton warehouse={warehouse} update={updateWarehouse} />
        <DeleteButton onClick={() => deleteWarehouse()} />
      </Stack>
    </td>
  </tr>
}